import {
    CommonModule
} from "@angular/common";

import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";

import {
    MatIconModule
} from "@angular/material/icon";

import {
    TilbyGesturesDirective
} from "@tilby/tilby-ui-lib/directives/tilby-gestures";

import {
    TilbyCurrencyPipe
} from "@tilby/tilby-ui-lib/pipes/tilby-currency";

import {
    Categories,
    Items
} from "tilby-models";

@Component({
    selector: 'tilby-item-element',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        TilbyCurrencyPipe,
        TilbyGesturesDirective
    ],
    templateUrl: './tilby-item-element.component.html',
    styleUrls: ['./tilby-item-element.component.scss']
})
  export class TilbyItemElementComponent implements OnChanges, OnInit {
    private static defaultElementColor = "BBDEFB";

    @Input() isHidePrices: boolean = false;
    @Input() item: any;
    @Input() itemCategory?: Categories | undefined;
    @Input() showThumbnail: boolean = true;
    @Input() showUnavailableStock: boolean = false;
    @Input() priceIdentifier: string = 'price';
    @Input() priceWithCurrency: boolean = true;
    @Input() truncatePriceWithDots: boolean = true;
    @Input() getStockStatus: Function = () => {};
    @Input() fontNameSize: number = 12;
    @Input() fontPriceSize: number = 12;
    @Input() showItemIconTest: boolean = false;

    @Output() itemTapped: EventEmitter<any> = new EventEmitter<any>();
    @Output() itemLongPressed: EventEmitter<any> = new EventEmitter<any>();

    protected backgroundColor = `#${TilbyItemElementComponent.defaultElementColor}`;

    itemTap(item: Items): void {
        this.itemTapped.emit(item);
    }

    itemPress(item: Items): void {
        this.itemLongPressed.emit(item);
    }

    ngOnInit(): void {
        this.updateBackgroundColor();
    }

    private updateBackgroundColor() {
        this.backgroundColor = `#${this.item.color || this.itemCategory?.color || TilbyItemElementComponent.defaultElementColor}`;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateBackgroundColor();

        if(changes.fontNameSize){
            this.fontNameSize = changes.fontNameSize.currentValue;
        }

        if(changes.fontPriceSize){
            this.fontPriceSize = changes.fontPriceSize.currentValue;
        }
    }
}
